import { useHistory, useLocation } from 'react-router-dom';
import { useCallback } from 'react';
import { PolicyData, PolicyTemplate } from '../../../../types/policies';

export const useHandleStartPolicyFromTemplate = () => {
    const history = useHistory<{ fromTemplateId: string; policy: Partial<PolicyData>; fromInsightId?: string }>();
    const location = useLocation<{ fromInsightId: string }>();
    const searchParams = new URLSearchParams(location.search);
    const fromInsightId = searchParams.get('fromInsightId') || undefined;

    const navigateToCreatePolicyFromTemplate = useCallback(
        (templateId: PolicyTemplate['id'], policyData: Partial<PolicyData>) => {
            history.push('/Policy', {
                fromTemplateId: templateId,
                policy: policyData,
                fromInsightId
            });
        },
        [history.push, fromInsightId]
    );

    return { navigateToCreatePolicyFromTemplate };
};
